import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import QRCode from "react-qr-code";
import { SuccessContent, Total } from "./style";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { FaCopy, FaCheckCircle, FaFileInvoice, FaCreditCard } from "react-icons/fa";
import { useDate } from "../../../hooks/useDate";
import { toast } from "react-toastify";
import { AuthContext } from "../../../context/Auth/AuthContext";
import { Button, Typography } from "@material-ui/core";

function CheckoutSuccess(props) {
  const { pix } = props;
  const [copied, setCopied] = useState(false);
  const history = useHistory();
  const { dateToClient } = useDate();
  const { user, socket } = useContext(AuthContext);

  const method = pix?.method || "mercadopago";
  const pixQrCodeBase64 = pix?.pixQrCodeBase64 || "";
  const pixCopiaCola = pix?.pixCopiaCola || "";
  const boletoUrl = pix?.boletoUrl || "";
  const boletoBarcode = pix?.boletoBarcode || "";
  const paymentLinkUrl = pix?.paymentLinkUrl || "";
  const urlMcPg = pix?.urlMcPg || "";

  useEffect(() => {
    const companyId = user?.companyId;
    if (!companyId || !socket) return;

    const onCompanyPayment = (data) => {
      if (data.action === "CONCLUIDA" || data.action === "approved") {
        toast.success(
          `Sua licenca foi renovada ate ${dateToClient(data.company.dueDate)}!`
        );
        setTimeout(() => {
          history.push("/");
        }, 4000);
      }
    };

    socket.on(`company-${companyId}-payment`, onCompanyPayment);

    return () => {
      socket.off(`company-${companyId}-payment`, onCompanyPayment);
    };
  }, [socket, user, history, dateToClient]);

  const handleCopy = (text) => {
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <React.Fragment>
      <Total>
        <span>TOTAL</span>
        <strong>
          R${" "}
          {pix?.valorext
            ? Number(pix.valorext).toLocaleString("pt-br", {
                minimumFractionDigits: 2,
              })
            : "0,00"}
        </strong>
      </Total>

      <SuccessContent>
        {/* ========== PIX ========== */}
        {method === "pix" && pixQrCodeBase64 && (
          <>
            <Typography variant="h6" align="center" style={{ fontWeight: 600 }}>
              Escaneie o QR Code PIX
            </Typography>
            <img
              src={`data:image/png;base64,${pixQrCodeBase64}`}
              alt="QR Code PIX"
              style={{ maxWidth: 256, margin: "16px auto", display: "block" }}
            />
            {pixCopiaCola && (
              <>
                <CopyToClipboard text={pixCopiaCola} onCopy={() => handleCopy(pixCopiaCola)}>
                  <button className="copy-button" type="button">
                    {copied ? (
                      <>
                        <span>Copiado</span>
                        <FaCheckCircle size={18} />
                      </>
                    ) : (
                      <>
                        <span>Copiar codigo PIX</span>
                        <FaCopy size={18} />
                      </>
                    )}
                  </button>
                </CopyToClipboard>
                <Typography
                  variant="caption"
                  align="center"
                  display="block"
                  style={{
                    wordBreak: "break-all",
                    marginTop: 8,
                    color: "#555",
                    maxWidth: 320,
                  }}
                >
                  {pixCopiaCola}
                </Typography>
              </>
            )}
            <Typography variant="body2" align="center" style={{ marginTop: 12 }}>
              Pagamento processado pelo Asaas. Assim que confirmado, sua licenca sera
              renovada automaticamente.
            </Typography>
          </>
        )}

        {method === "pix" && !pixQrCodeBase64 && (
          <Typography variant="body1" align="center" color="error">
            Erro ao gerar QR Code PIX. Tente novamente ou escolha outro metodo.
          </Typography>
        )}

        {/* ========== BOLETO ========== */}
        {method === "boleto" && (
          <>
            <Typography variant="h6" align="center" style={{ fontWeight: 600 }}>
              Boleto gerado com sucesso
            </Typography>
            <FaFileInvoice size={48} color="#1565c0" style={{ margin: "16px auto", display: "block" }} />

            {boletoBarcode && (
              <>
                <Typography variant="subtitle2" align="center" style={{ marginTop: 8 }}>
                  Codigo de barras:
                </Typography>
                <CopyToClipboard text={boletoBarcode} onCopy={() => handleCopy(boletoBarcode)}>
                  <button className="copy-button" type="button">
                    {copied ? (
                      <>
                        <span>Copiado</span>
                        <FaCheckCircle size={18} />
                      </>
                    ) : (
                      <>
                        <span>Copiar codigo</span>
                        <FaCopy size={18} />
                      </>
                    )}
                  </button>
                </CopyToClipboard>
                <Typography
                  variant="caption"
                  align="center"
                  display="block"
                  style={{ wordBreak: "break-all", marginTop: 4, color: "#555" }}
                >
                  {boletoBarcode}
                </Typography>
              </>
            )}

            {boletoUrl && (
              <Button
                variant="contained"
                color="primary"
                style={{ marginTop: 16 }}
                onClick={() => window.open(boletoUrl, "_blank")}
              >
                <FaFileInvoice size={16} style={{ marginRight: 8 }} />
                Visualizar / Imprimir Boleto
              </Button>
            )}

            <Typography variant="body2" align="center" style={{ marginTop: 12 }}>
              O boleto pode levar ate 1 dia util para ser compensado. Sua licenca sera
              renovada automaticamente apos a confirmacao.
            </Typography>
          </>
        )}

        {/* ========== CARTAO ========== */}
        {method === "cartao" && paymentLinkUrl && (
          <>
            <Typography variant="h6" align="center" style={{ fontWeight: 600 }}>
              Pagamento com Cartao de Credito
            </Typography>
            <FaCreditCard size={48} color="#ff9800" style={{ margin: "16px auto", display: "block" }} />

            <Button
              variant="contained"
              style={{
                backgroundColor: "#ff9800",
                color: "#fff",
                marginTop: 16,
                fontWeight: 600,
              }}
              onClick={() => window.open(paymentLinkUrl, "_blank")}
            >
              <FaCreditCard size={16} style={{ marginRight: 8 }} />
              Ir para pagamento seguro
            </Button>

            <Typography variant="body2" align="center" style={{ marginTop: 12 }}>
              Voce sera redirecionado para o checkout seguro do Asaas para inserir os
              dados do seu cartao.
            </Typography>
          </>
        )}

        {/* ========== MERCADO PAGO ========== */}
        {method === "mercadopago" && (
          <>
            <Typography variant="h6" align="center" style={{ fontWeight: 600 }}>
              Mercado Pago
            </Typography>
            <Typography variant="body1" align="center" style={{ marginTop: 16 }}>
              O pagamento foi aberto em uma nova aba. Finalize-o la e volte aqui.
            </Typography>
            {urlMcPg && (
              <Button
                variant="outlined"
                color="primary"
                style={{ marginTop: 16 }}
                onClick={() => window.open(urlMcPg, "_blank")}
              >
                Reabrir Mercado Pago
              </Button>
            )}
          </>
        )}
      </SuccessContent>
    </React.Fragment>
  );
}

export default CheckoutSuccess;
